import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCalculatorIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 20,
	height: 20,
	viewBox: "0 0 20 20",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M15.2734 1.21094H4.72656C4.07935 1.21094 3.55469 1.7356 3.55469 2.38281V17.6172C3.55469 18.2644 4.07935 18.7891 4.72656 18.7891H15.2734C15.9206 18.7891 16.4453 18.2644 16.4453 17.6172V2.38281C16.4453 1.7356 15.9206 1.21094 15.2734 1.21094Z",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.5156 3.55469H6.48438C6.16077 3.55469 5.89844 3.81702 5.89844 4.14062V6.48438C5.89844 6.80798 6.16077 7.07031 6.48438 7.07031H13.5156C13.8392 7.07031 14.1016 6.80798 14.1016 6.48438V4.14062C14.1016 3.81702 13.8392 3.55469 13.5156 3.55469Z",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.77734 10.5859C6.61554 10.5859 6.48438 10.4548 6.48438 10.293C6.48438 10.1312 6.61554 10 6.77734 10",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.77734 10.5859C6.93915 10.5859 7.07031 10.4548 7.07031 10.293C7.07031 10.1312 6.93915 10 6.77734 10",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.77734 13.5156C6.61554 13.5156 6.48438 13.3845 6.48438 13.2227C6.48438 13.0609 6.61554 12.9297 6.77734 12.9297",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.77734 13.5156C6.93915 13.5156 7.07031 13.3845 7.07031 13.2227C7.07031 13.0609 6.93915 12.9297 6.77734 12.9297",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.77734 16.4453C6.61554 16.4453 6.48438 16.3141 6.48438 16.1523C6.48438 15.9905 6.61554 15.8594 6.77734 15.8594",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.77734 16.4453C6.93915 16.4453 7.07031 16.3141 7.07031 16.1523C7.07031 15.9905 6.93915 15.8594 6.77734 15.8594",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.1221 10.5859C9.96027 10.5859 9.8291 10.4548 9.8291 10.293C9.8291 10.1312 9.96027 10 10.1221 10",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.1221 10.5859C10.2839 10.5859 10.415 10.4548 10.415 10.293C10.415 10.1312 10.2839 10 10.1221 10",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.1221 13.5156C9.96027 13.5156 9.8291 13.3845 9.8291 13.2227C9.8291 13.0609 9.96027 12.9297 10.1221 12.9297",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.1221 13.5156C10.2839 13.5156 10.415 13.3845 10.415 13.2227C10.415 13.0609 10.2839 12.9297 10.1221 12.9297",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.1221 16.4453C9.96027 16.4453 9.8291 16.3141 9.8291 16.1523C9.8291 15.9905 9.96027 15.8594 10.1221 15.8594",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.1221 16.4453C10.2839 16.4453 10.415 16.3141 10.415 16.1523C10.415 15.9905 10.2839 15.8594 10.1221 15.8594",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.2227 10.5859C13.0609 10.5859 12.9297 10.4548 12.9297 10.293C12.9297 10.1312 13.0609 10 13.2227 10",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.2227 10.5859C13.3845 10.5859 13.5156 10.4548 13.5156 10.293C13.5156 10.1312 13.3845 10 13.2227 10",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.2227 13.5156C13.0609 13.5156 12.9297 13.3845 12.9297 13.2227C12.9297 13.0609 13.0609 12.9297 13.2227 12.9297",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.2227 13.5156C13.3845 13.5156 13.5156 13.3845 13.5156 13.2227C13.5156 13.0609 13.3845 12.9297 13.2227 12.9297",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.2227 16.4453C13.0609 16.4453 12.9297 16.3141 12.9297 16.1523C12.9297 15.9905 13.0609 15.8594 13.2227 15.8594",
			strokeWidth: 1.5
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.2227 16.4453C13.3845 16.4453 13.5156 16.3141 13.5156 16.1523C13.5156 15.9905 13.3845 15.8594 13.2227 15.8594",
			strokeWidth: 1.5
		})
	]
});
export default SvgCalculatorIcon;
